/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargePointDriveResult } from '../../models/charge-point-drive-result';

export interface ClearcacheChargePoint$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected charge point
 */
  chargePointUid: string;
}

export function clearcacheChargePoint(http: HttpClient, rootUrl: string, params: ClearcacheChargePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointDriveResult>> {
  const rb = new RequestBuilder(rootUrl, clearcacheChargePoint.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('chargePointUid', params.chargePointUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargePointDriveResult>;
    })
  );
}

clearcacheChargePoint.PATH = '/stations/{uid}/drive/chargepoints/{chargePointUid}/clearcache';
